import { useEffect, useRef } from "react";
import { Platform, View } from "react-native";

function useClickOutside(callback: () => void, ignoreRef?: React.RefObject<View>) {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    if (Platform.OS !== "web") return;
    function handleClick(event: MouseEvent) {
      const target = event.target as Node;
      if (
        ref.current &&
        !ref.current.contains(target) &&
        !(ignoreRef?.current as unknown as HTMLElement)?.contains?.(target)
      ) {
        callback();
      }
    }

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [callback, ignoreRef]);

  return ref;
}

export default useClickOutside;
